import { useEffect, useState } from 'react';
export function useElementStyle(elementRef) {
    const [style, setStyle] = useState(null);
    useEffect(() => {
        if (elementRef.current) {
            setStyle(window.getComputedStyle(elementRef.current));
        }
        else {
            setStyle(null);
        }
    }, [elementRef]);
    return style;
}
//# sourceMappingURL=useElementStyle.js.map